module.exports = __webpack_public_path__ + "static/media/Samwell Tarly 2.b8ef627a.jpg";